/**
 * Taken from https://css-tricks.com/snippets/jquery/smooth-scrolling/
 */
;(function( $ ) {
    'use strict';

    // Select all links with hashes
    $( 'a[href*="#"]' )
        // Remove links that don't actually link to anything
        .not( '[href="#"]' )
        .not( '[href="#0"]' )
        .not( '.toggle' )
        .on( 'click', function( event ) {
            var target = $( this.hash );

            // On-page links
            if ( location.pathname.replace( /^\//, '' ) !== this.pathname.replace( /^\//, '' ) || location.hostname !== this.hostname ) {
                // We're not going to touch this link so exit...
                return;
            }

            // Figure out element to scroll to
            target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );

            // Does a scroll target exist?
            if ( !target.length ) {
                // Nope!!
                return;
            }

            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            target[ 0 ].scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center'
                }
            );
        } );
}( jQuery ));
